import { Paper, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";

export const DetailPanel = ({
  open,
  children,
}: PropsWithChildren<{ open: boolean }>) => {
  const theme = useTheme();
  if (!open) return null;
  return (
    <Paper
      sx={{
        width: "100%",
        maxWidth: theme.spacing(65),
        overflowX: "hidden",
        overflowY: "scroll",
      }}
    >
      {children}
    </Paper>
  );
};
